import React, { ReactElement, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router'
import { IStepProps } from '../../interfaces/Step'
import Contact from './Contact'
import Logement from './Logement'
import Step4FormHook from '../../hooks/Step4FormHook'
import { handleError, preventEnterFormSubmit } from '../../services/utils'
import SubmitButton from '../SubmitButton'
import AddressSection from './AddressSection'
import JddAddressHook from '../../hooks/JddAddressHook'
import Step4AddressHook from '../../hooks/Step4AddressHook'
import { STATUS } from '../../enums/common'
import Spinner from '../Spinner'
import AddressQuestion from './AddressQuestion'
import { addressActions } from '../../store/slices/Address'
import { getUserAddress } from '../../services/Kyc'
import { IStore } from '../../interfaces/Store'

function Step4Form(props: IStepProps): ReactElement {
  const {
    errors,
    handleNextStep,
    handleSubmit,
    logementProps,
    submitForm,
    register,
    triggerValidation,
    control,
    isJddDocUploaded,
    setValue,
    setError,
    clearError,
  } = Step4FormHook(props)
  const { status: citiesStatus } = useSelector(
    (state: IStore) => state.citiesReducer
  )
  const { watch, state } = logementProps
  const dispatch = useDispatch()
  const history = useHistory()
  useEffect(() => {
    async function getAddress() {
      dispatch(addressActions.addressLoading())
      try {
        const response = await getUserAddress()
        // @ts-ignore
        dispatch(addressActions.addressReceived(response))
      } catch (e) {
        dispatch(addressActions.addressFailed())
        handleError(e, history)
      }
    }
    getAddress()
    // eslint-disable-next-line
  }, [dispatch])
  const watchAddress = watch('existing_address')
  const watchSituationLogement = watch('situation_logement')
  const {
    address,
    addressStatus,
    existing_address,
    userAddress,
    showUpload,
    showUploadSelect,
  } = Step4AddressHook(watchAddress)
  const isUploadDocDisplayed =
    !address || (showUpload && watchSituationLogement !== '')
  JddAddressHook(isJddDocUploaded, isUploadDocDisplayed)
  const disableRadio = state[0].status === STATUS.validated

  if (addressStatus === STATUS.pending) {
    return (
      <div className="col12 mt1 dFlex alignItemsCenter justifyContentCenter justifyContentLgStart">
        <div className="relative pb3 pl3">
          <Spinner small={true} />
        </div>
      </div>
    )
  }
  return (
    // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
    <form
      onSubmit={handleSubmit(submitForm)}
      onKeyPress={preventEnterFormSubmit}
    >
      <Contact
        setValue={setValue}
        errors={errors}
        register={register}
        triggerValidation={triggerValidation}
        watch={watch}
      />
      <div className="card cardContent mb2 mb0md px25 py25 cardSmContent">
        <div className="row">
          {address && (
            <div className="colLg6">
              <AddressQuestion
                existing_address={existing_address}
                error={errors.existing_address}
                register={register}
                disableRadio={disableRadio}
                userAddress={userAddress}
              />
            </div>
          )}
          {showUpload && (
            <Logement
              {...logementProps}
              address={address}
              showUploadSelect={showUploadSelect}
            />
          )}
        </div>
      </div>
      {isJddDocUploaded && isUploadDocDisplayed && (
        <AddressSection
          register={register}
          errors={errors}
          control={control}
          triggerValidation={triggerValidation}
          setValue={setValue}
          watch={watch}
          setError={setError}
          clearError={clearError}
        />
      )}
      <div className="pt5md textRight">
        <SubmitButton
          disabled={citiesStatus === STATUS.pending}
          label="Étape suivante"
          onClick={handleNextStep}
        />
      </div>
    </form>
  )
}

export default Step4Form
